export const color = {
  theme: '#45B4A8',
  edit: '#ff7b54',
  submit: '#FCE100',
  clear: '#707070',
  remove: '#d35d6e',
  search: '#1890ff',
  red: '#FF0000',
  logout: '#C1C1C1',
  black_grey: '#242424',
  yellow: '#FFF129',
  black:'#000000',
  darkgreen:'#2F8F88',
  lightgreen:'#F3FFFD',
  lightred:'#FFEDED',
  white:'#ffffff',
  darkgrey:'#414141',
};
